module.exports = __webpack_public_path__ + "img/top-5-1.d1ac4fba.jpg";